var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3713 25.2298L20.3712 25.2293C20.3546 25.157 20.3356 25.0789 20.3152 24.995C20.1656 24.3788 19.9401 23.4505 20.0193 22.2302C20.1098 20.8372 20.5851 19.1226 21.8442 16.9419C23.4153 14.2205 22.7779 10.9341 20.4874 8.89079L19.8802 8.34918L20.287 7.64457L20.7755 6.79857C20.9138 6.55902 20.8313 6.25348 20.5933 6.11603C20.3552 5.97857 20.0494 6.05996 19.9111 6.29951L19.4226 7.14551L19.0158 7.85012L18.2432 7.59513C15.3284 6.63313 12.1635 7.72427 10.5924 10.4456C9.33333 12.6264 8.08606 13.8953 6.92491 14.6702C5.90776 15.349 4.99111 15.6178 4.38261 15.7963C4.29976 15.8206 4.22262 15.8432 4.15171 15.865C4.00839 15.909 3.92217 15.9898 3.86939 16.0827C3.86937 16.0827 3.86936 16.0827 3.86935 16.0827M20.3713 25.2298L3.00003 15.5885L3.86935 16.0827M20.3713 25.2298C20.4047 25.3748 20.3781 25.4901 20.3238 25.5827L20.3235 25.5832C20.1827 25.8237 19.8831 25.9133 19.6334 25.7691L4.05312 16.7738C3.80385 16.6299 3.73117 16.3259 3.86935 16.0827M20.3713 25.2298L3.86935 16.0827M11.5925 25.1681C10.9942 25.5131 10.2336 25.5383 9.59327 25.1686C8.95298 24.7989 8.59446 24.1276 8.59403 23.437L11.5925 25.1681Z",
    stroke: "#A1C7FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1571c8e73a6e7806224b0a3fa159d7c8.svg";
export { ForwardRef as ReactComponent };